{
  "defaultTitle": "चेक-इन करने में असमर्थ",
  "defaultMessage": "कृपया अपने डिस्पैचर से जानकारी की पुष्टि करें या वेयरहाउस से संपर्क करें",
  "backToHomescreen": "होम स्क्रीन पर वापस जाएं",
  "hideErrorLog": "त्रुटि लॉग छुपाएं",
  "viewErrorLog": "त्रुटि लॉग देखें",
  "errorLogMessageLabel": "संदेश:",
  "errorLogStatusLabel": "स्टेटस कोड:",
  "unknown": "अज्ञात"
}
